import {API_BASE_URL} from "../apiConfig.jsx";
import axios from "axios";

const storedUser = JSON.parse(localStorage.getItem("user")) || {};
const navemail = localStorage.getItem("navemail")|| {};

const generateMenu = async () => {
   const fetchMenu = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/getmenu`,
          { uid : storedUser?.id },{ headers: { 'Content-Type': 'application/json' } });
        return response.data;
      } catch (error) {
        console.error("Failed to fetch menu:", error);
      }
    };

       const mn = await fetchMenu();
       //console.log("mn",mn)    
       const baseMenu = mn.map(item => ({
        ...item,
        path: item.c_name,
        title: item.c_arabic_name,
        children: item.childrens.map(child => ({
          ...child,
        path: child.c_path,
        title: child.c_sub_cat_name,
        }))
      })); 
      //console.log("base",baseMenu)
     return baseMenu; // Default menu if no user type is found
};

const Menu = await generateMenu();

export default Menu;